module.exports = __webpack_public_path__ + "img/V79.dffe2aa1.jpg";